import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoutes = () => {
    //This is not a secure way to check. It should be done with JWT tokens
    const {user} = useAuth()
    return user ? <Outlet/> : <Navigate to="/login" />
}

export default PrivateRoutes